module.exports = __webpack_public_path__ + "static/media/Y2.e5ebc43b.mp3";